import React, { ComponentProps } from "react";
import { LegacyText, Flex } from "flicket-ui";
import startCase from "lodash/startCase";
import { ColorPath } from "flicket-ui/build/styles/colors.types";

const STATUS_COLORS: Record<string, ColorPath> = {
  Completed: "success",
  PartPaid: "green.100",
  Paid: "success",
  Success: "success",
  Waiting: "warning",
  Pending: "warning",
  Unknown: "warning",
  Transferred: "warning",
  Hold: "yellow.100",
  Expired: "N300",
  Error: "error",
  Failure: "error",
  Canceled: "error",
  Precharge: "blue.500",
};

type TagProps = ComponentProps<typeof Flex> & {
  status: string;
  dot?: number;
  textProps?: ComponentProps<typeof LegacyText>;
};

export const Tag = ({
  status,
  height = 24,
  dot = 16,
  textProps = {},
  ...props
}: TagProps) => {
  let message = startCase(status);
  if (status === "Precharge") {
    message = "Pre-authorized";
  }
  return (
    <Flex
      display="inline-flex !important"
      borderRadius="full"
      bg="N200"
      p="1/2"
      pr={1}
      alignItems="center"
      height={height}
      color="N700"
      fontSize={1}
      {...props}
    >
      <Flex
        borderRadius="full"
        width={dot}
        height={dot}
        bg={STATUS_COLORS[status]}
        mr="1/2"
      />
      <LegacyText fontWeight="extraBold" {...textProps}>
        {message}
      </LegacyText>
    </Flex>
  );
};
